import React from 'react';
import { connect } from 'react-redux';
import Chart from 'react-apexcharts';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import { TitleTooltip } from './TitleTooltip';
import { LoadingView } from './LoadingView';
import { StoreUtil, CsvUtil  } from 'doctivity-shared/utils';
import { withIsMobile} from 'utils';
import { listClaimsPayersByOrganization } from 'store/actions/claimsActions';
import fileDownload from 'js-file-download';
import moment from 'moment';
import { ColorUtil } from 'utils';
import {
  Card,
  CardContent,
  Typography
} from '@mui/material';

const styles = (theme) => ({
  card: {
    height: '100%',
  },
  leftIcon: {
    marginRight: theme.spacing(),
  },
  nothingFound: {
    fontWeight: 300,
    fontSize: 12,
  },
  noData: {
    color: '#9E9E9E',
    fontStyle: 'italic',
    fontSize: 13,
    textAlign: 'center',
  },
});

class ClaimsOrgPayers extends React.Component {
  componentDidMount() {
    const { payers } = this.props;

    if (StoreUtil.needsLoadNoCache(payers)) {
      this.fetchPayers();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.organization !== prevProps.organization || this.props.patientType !== prevProps.patientType) {
      this.fetchPayers();
    }
  }

  fetchPayers() {
    this.props.dispatch(listClaimsPayersByOrganization(this.props.organization.data.id, this.props.patientType));
  }

  render() {
    const { classes, payers, isMobile, patientType } = this.props;

    if (!payers || !StoreUtil.isLoaded(payers)) {
      return <LoadingView />;
    }

    const labels = [];
    const data = [];
    const newdata = [];
    const max = 9;
    let i = 0;
    let otherData = 0;
    payers.data.forEach((p) => {
      if (i < max) {
        let name = p.payer.name;
        if (name.startsWith('Other')) {
          otherData += parseFloat(p.percent);
          return; // don't let i increment here
        }
        if (name.length > 20) {
          name = `${name.substring(0, 20)}...`;
        }
        labels.push(name);
        data.push(parseFloat(p.percent));

        newdata.push({name: name, data: [p.percent]});

      } else if (i === max) {
        labels.push('Other');
        data.push(parseFloat(p.percent) + otherData);

        newdata.push({name: 'Other', data: [parseFloat(p.percent) + otherData]});
      } else {
        data[max] += parseFloat(p.percent);
        data[max] = data[max].toFixed(2) * 1;

        newdata[max].data[0] += parseFloat(p.percent);
        newdata[max].data[0] = newdata[max].data[0].toFixed(2) * 1;
      }
      i++;
    });

    // this means other was included in data, but we didn't hit the max
    if (otherData > 0 && i <= max) {
      labels.push('Other');
      data.push(otherData);

      newdata.push({name: 'Other', data: [otherData]});
    }

    return (
 
      <Card
        className={classes.card}
        style={{ height: isMobile ? 450 : '100%' }}
      >
        { payers.data.length==0 && (
          <CardContent style={{ height: isMobile ? '100%' : 100 }}>
            <TitleTooltip
              title='Payor'
              tooltip="Insight into the payors that are affiliated to an organization based on their patient's claims."
              rightLabel={patientType==='PEDIATRIC_PATIENTS' ? 'Claims from pediatric patients' : 'Claims from all ages'}
            />
            <Typography
                        noWrap
                        className={classes.noData}
                      >No payor data available for this organization.
            </Typography>
          </CardContent>
        )}

        { payers.data.length>0 && (
          <CardContent style={{ height: isMobile ? '100%' : 180 }}>
            <TitleTooltip
              title='Payor'
              tooltip="Insight into the payors that are affiliated to an organization based on their patient's claims."
              rightLabel={patientType==='PEDIATRIC_PATIENTS' ? 'Claims from pediatric patients' : 'Claims from all ages'}
              onExport={() => {
                this.downloadPayorData();
              }}

            />

            <Chart
              type='bar'
              height={isMobile ? 300 : 150}
              options={{
                chart: {
                  toolbar: {
                    show: false
                  },
                  stacked:true,
                  animations: {
                    enabled: false,
                  },
                },
                plotOptions: {
                  bar: {
                    horizontal: true,
                    dataLabels: {
                      total: {
                        enabled: false,
                      },
                    }
                  },
                },

                grid:{
                  show: false
                },
                dataLabels: {

                  formatter: function(val) {
                    return val + '%'
                  },
                 
                },
                xaxis: {
                  show: false,
                  labels: {
                    show: false
                  },
                  axisBorder: {
                    show: false
                  },
                  axisTicks: {
                    show: false
                  },
                  max: 100,
                },
                legend: {
                  onItemClick: {
                    toggleDataSeries: false
                  },
                 },
                yaxis: {
                  show: false,
                  lines: {
                    show: false
                  }
                },
                tooltip: {
                  x: false,
                  y: {
                    formatter: function (y) {
                      return y + '%';
                    }
                  }
                
                },
             //   responsive: [
               //   {
                 //   breakpoint: 900,
                   // options: {
                     // legend: {
                       // position: 'bottom',
                      //},
                    //},
                  //},
                //],
                //labels,
              }}
              series={newdata}
              colors={ColorUtil.COLORS}
            />
          </CardContent>
        )}
      </Card>

    );
  }

 

  downloadPayorData() {
    const { organization, payers } = this.props;
    const data = payers.data.map((p) => {
      return  [
        //organization.data.npi,
        //organization.data.name,
        p.payer.name,
        p.percent,
      ];
    });
    const header = ['Payer', 'Percent'];
    const filename = `doctivity_${organization.data.name}_PAYORS_${moment().format('YY_MM_DD')}.csv`;
    fileDownload(CsvUtil.matrixToString([header, ...data]), filename);
  }
}

ClaimsOrgPayers.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  classes: PropTypes.object,
  payers: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.object,
  patientType: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    payers: StoreUtil.get(state.claims, 'payers_list'),
  };
}

const styled = withIsMobile(withStyles(styles)(ClaimsOrgPayers));
const connected = connect(mapStateToProps)(styled);
export { connected as ClaimsOrgPayers }; 
